const API_BASE_URL = '/api/print-profile';

class PrintProfileService {
  getToken() {
    return localStorage.getItem('auth_token');
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = this.getToken();
    const config = {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object' && !(config.body instanceof FormData)) {
      config.body = JSON.stringify(config.body);
    }

    const response = await fetch(url, config);
    const data = await response.json();
    if (!response.ok) {
      // Auto-logout jika token expired
      if (response.status === 401 && data.error && data.error.includes('Token expired')) {
        window.dispatchEvent(new CustomEvent('auth:token-expired'));
      }
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
    return data;
  }

  async getProfile() {
    return this.request('/');
  }

  async updateProfile(data) {
    return this.request('/', {
      method: 'PUT',
      body: data,
    });
  }
}

export const printProfileService = new PrintProfileService();
export default printProfileService;
